//  reputation Manager review sites
if (document.getElementById('countryChoose')) {
    const showSites = () => {

        let country = document.getElementById('countryChoose').value;
        let category = document.getElementById('categoryChoose').value;

        if (country == 'usa') {
            if (document.getElementById('categoryChoose')) {
                let categorydpdwn = document.getElementById('categoryChoose');
                categorydpdwn.classList.remove('hideme');
            }

            document.querySelectorAll('#rm-sites .reviewsite').forEach(function (teamer) {

                teamer.classList.remove('hello');
                teamer.classList.remove('grow');
                teamer.classList.remove('destroy');
                teamer.classList.remove('fadein');

                if (teamer.classList.contains(country) && teamer.classList.contains(category)) {
                    //  teamer.classList.add('hello');
                    setTimeout(function (e) {
                        teamer.classList.add('destroy');
                    }, 0)
                    setTimeout(function (e) {
                        teamer.classList.add('grow');
                    }, 200);
                    setTimeout(function (e) {
                        teamer.classList.add('hello');
                    }, 400);
                    setTimeout(function (e) {
                        teamer.classList.add('fadein');
                    }, 600);
                } else {
                    teamer.classList.remove('fadein');
                    setTimeout(function (e) {
                        teamer.classList.remove('hello');
                    }, 150);
                    setTimeout(function (e) {
                        teamer.classList.remove('grow');
                    }, 300);
                    setTimeout(function (e) {
                        teamer.classList.remove('destroy');
                    }, 300);
                }
            });
        } else {
            if (document.getElementById('categoryChoose')) {
                let categoryElement = document.getElementById('categoryChoose');
                categoryElement.classList.add('hideme');
            }
            document.querySelectorAll('#rm-sites .reviewsite').forEach(function (teamer) {
                teamer.classList.remove('hello');
                teamer.classList.remove('grow');
                teamer.classList.remove('destroy');
                teamer.classList.remove('fadein');
                if (teamer.classList.contains(country)) {
                    //  teamer.classList.add('hello');
                    setTimeout(function (e) {
                        teamer.classList.add('destroy');
                    }, 0)
                    setTimeout(function (e) {
                        teamer.classList.add('grow');
                    }, 200);
                    setTimeout(function (e) {
                        teamer.classList.add('hello');
                    }, 400);
                    setTimeout(function (e) {
                        teamer.classList.add('fadein');
                    }, 600);
                } else {
                    teamer.classList.remove('fadein');
                    setTimeout(function (e) {
                        teamer.classList.remove('hello');
                    }, 150);
                    setTimeout(function (e) {
                        teamer.classList.remove('grow');
                    }, 300);
                    setTimeout(function (e) {
                        teamer.classList.remove('destroy');
                    }, 300);
                }
            });
        }
    }

    let countrySelect = document.getElementById('countryChoose');
    let categorySelect = document.getElementById('categoryChoose');

    countrySelect.addEventListener('change', function () {
        showSites(); //  Do something damnit
    });

    categorySelect.addEventListener('change', function () {
        showSites(); //  Do something damnit
    });

    showSites();
}